import './styles.scoped.css';
import postsData from '../../jsondata/posty.json';
import { Col, Container, Row } from 'react-bootstrap';
import pliki from '../../jsondata/img_path.json';
interface FrontPostProps {
  postNumber: number,
};

const FrontPost: React.FC<FrontPostProps> = ({ postNumber }) => {
  return (
    <Row className="post">
      
      <Row sm={12} lg={12} className="textTile">
        <h3>{postsData[postNumber].title}</h3>
        <p dangerouslySetInnerHTML={{ __html: postsData[postNumber].description }} />
      </Row>
      <Row sm={12} lg={12} className="photoTile">
        <Row>
          <small>{postsData[postNumber].postAddDate} autor-{postsData[postNumber].autor}</small>
        </Row>
        <Row>
          {
            pliki.map((dane) =>
              postsData[postNumber].fileID === dane.ID && <img key={dane.ID} src={`/images_photo/${dane.filename}`} alt="zdjęcie postu" className='img' />
            )
          }
        </Row>
      </Row>
    </Row>
  );
}
export default FrontPost;